import React , {useState, useEffect}  from "react";
import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import {Links} from '../../routes/PathLink'
import {APP_URL, APP_NAME, API_ENDPOINT, IMG_URL} from '../config/Common'
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {CloseIcon} from "../../custom-icons";
import ModalView from '../../_utils/ModalView'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
const testimonialBreakpoints = {
	320: {
		slidesPerView: 1,
	},
}

const bannerTemp = [
   {image:'slider_images/1681817173.jpg'},
   {image:'slider_images/1682598070.jpg'},
   {image:'slider_images/1681817173.png'},
]

const Sponsered = (props) => {

     const [bannerloading, setBannerloading] = useState(false)
      const [banner, setBanner] = useState(null)   
   useEffect(() => {
      get_page_banner()
   },[]);
   const get_page_banner = () => {
      setBannerloading(true);

      fetch(`${API_ENDPOINT}/get_home_slider`,{
         method: 'GET',
         headers : {        
            'Content-Type': 'application/json',
            'Accept': 'application/json', 
         }
      }).then(function (response) {
            return response.json();
      }).then( (result)=> {
         //console.log('slider======',result)
        setBannerloading(false);
         if(result.status === 1){
           setBanner(result.data);    
           //setBanner(bannerTemp)
         }
      })
     setBannerloading(false);
   }

   return(
      <>
     
            <div className="bg-light p-2 md:min-h-0 md:rounded-xl">
               
                <div class="text-xs text-gray-500 -mt-2">Sponsored</div>
                <button aria-label="Close panel" class="absolute -top-3 z-[60] bg-gray-900 p-1 text-light rounded-full inline-block outline-none focus:outline-none ltr:-right-2" tabindex="0"  onClick={props?.closeSponsered}>
                <CloseIcon className="h-4 w-4"  />
                </button>
                {
                  banner && banner.map((val,key) => (
                  <div key={`slider-${key}`}>
                     <div className="">
                     <LazyLoadImage alt="Slider images " src={`${IMG_URL}/${val.image}`} className="w-full object-fit-cover " /></div>

                     
                  </div>
                  ))
                  }
                   
              
            </div>
      </>
   )
}

export default Sponsered